/**
 * Spring presets for motion/react.
 *
 * Mirrors the `--gb-spring-*` CSS tokens in app/frontend/styles/motion.css.
 * Components MUST consume one of `springInteractive` / `springBrand` rather
 * than the raw primitives — same rule as the color and motion-duration tokens.
 *
 * Format matches motion/react's spring transition shape:
 * { type: "spring", visualDuration, bounce }
 */

import type { Transition } from "motion/react"

const spring = (visualDuration: number, bounce: number): Transition => ({
  type: "spring",
  visualDuration,
  bounce,
})

// Primitives (do not consume directly from components).
export const springTight = spring(0.22, 0.08)
export const springStandard = spring(0.35, 0.18)
export const springPlayful = spring(0.45, 0.28)

// Semantic aliases — what components reach for.
export const springInteractive = springStandard
export const springBrand = springPlayful
